<template>
  <div>
    <div
      class="floated-chat-btn"
      @click="abrirModalPickear()"
      style="z-index: 1000 !important"
      data-toggle="modal"
      v-if="despachoe.estado == 'A'"
    >
      <i class="fas fa-check"></i>&nbsp;&nbsp;Pickear
    </div>
    <div
      class="modal fade"
      id="pickearModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
            <h6 class="modal-title">Pickeo de Producto.</h6>

            <h6 style="color: blue" v-if="producto">
              {{ producto.sku }} {{ producto.nombre }}
              <br />
              Pendiente: {{ pendiente_pickear.cantidad_pendiente }}
            </h6>
            <small v-if="errors" class="form-text text-danger">{{
              errors.producto
            }}</small>
            <div class="form-group">
              <input
                v-if="!producto"
                ref="barrax"
                id="barra"
                name="barra"
                @change="refreshProducto(barra)"
                v-on:keyup.enter="refreshProducto(barra)"
                class="form-control"
                placeholder="Producto"
                type="text"
                v-model="barra"
              />
              <button
                v-if="producto"
                @click="clearProducto()"
                class="btn btn-md btn-block btn-dark"
              >
                Cambiar Producto
              </button>
              <small
                v-if="error_pickeo && error_pickeo.barra"
                class="form-text text-danger"
                >{{ error_pickeo.barra }}</small
              >
            </div>
            <div class="row">
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <input
                    class="form-control"
                    ref="posicionx"
                    v-on:keyup.enter="nextInputFocus()"
                    placeholder="Localización"
                    type="text"
                    v-model="localizacion_origen"
                  />
                  <small
                    v-if="error_pickeo && error_pickeo.localizacion_origen"
                    class="form-text text-danger"
                    >{{ error_pickeo.localizacion_origen }}</small
                  >
                </div>
              </div>
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <input
                    ref="cantidadx"
                    class="form-control"
                    placeholder="Cantidad"
                    type="number"
                    step="0.01"
                    v-model="cantidad"
                  />
                  <small
                    v-if="error_pickeo && error_pickeo.cantidad"
                    class="form-text text-danger"
                    >{{ error_pickeo.cantidad }}</small
                  >
                </div>
              </div>
            </div>
            <small
              v-if="error_pickeo && error_pickeo.detail"
              class="form-text text-danger"
              >{{ error_pickeo.detail }}</small
            >
            <button class="btn btn-block btn-primary" type="button" @click="pickear()">
              Pickear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    despachoe: {
      type: Object,
    },
  },
  data() {
    return {
      errors: [],
      error: [],
      error_pickeo: [],
      isModalOpen: false,
      barra: null,
      localizacion_origen: null,
      cantidad: null,
      lote: null,
      producto: "",
      pendiente_pickear: {
        cantidad_pendiente: null,
      },
    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barrax.focus();
    });
  },
  methods: {
    nextInputFocus() {
      this.$refs.cantidadx.focus();
    },
    abrirModalPickear() {
      this.clearProducto();
      $("#pickearModal").modal("show");
    },
    clearProducto() {
      if (this.producto) {
        this.producto = "";
        this.barra = "";
      }
    },
    refreshDetalleDefault() {
      let self = this;
      self.producto = null;
      self.barra = "";
      self.cantidad = "";
      self.localizacion_origen = "";
      self.posicion = "";
      self.errors = [];
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.producto = response.data.results[0].producto_obj;
          self.pendientePickear(barra);
          self.errors.producto = "";
          self.cleanErrors();
          setTimeout(function () {
            self.$refs.posicionx.focus();
          }, 100);
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    pendientePickear(barra) {
      DynamicService.postAction(
        "wms",
        "picking-despacho",
        this.despachoe.id,
        "consultar_producto_picking",
        {
          barra: barra,
        }
      )
        .then((response) => {
          this.pendiente_pickear = response.data;
        })
        .catch((err) => {});
    },
    pickear() {
      let self = this;
      let fecha_proceso = localStorage.getItem("fecha_proceso");
      fecha_proceso = new Date(fecha_proceso);
      if (fecha_proceso) {
        fecha_proceso.setSeconds(fecha_proceso.getSeconds() + 5);
        if (fecha_proceso > new Date()) {
          let tiempo_espera = fecha_proceso - new Date();
          tiempo_espera = Math.floor(tiempo_espera / 1000);
          Notifications.alert.error(
            "Finalizar Recepción",
            "Este proceso solo se puede ejecutar una vez cada 5 seg, faltan  " +
              tiempo_espera +
              " seg. para el proximo intento"
          );
          self.$emit("refreshCurrent");
          return;
        }
      }

      DynamicService.postAction(
        "wms",
        "picking-despacho",
        self.despachoe.id,
        "pickear_sap",
        {
          barra: self.barra,
          localizacion_origen: self.localizacion_origen,
          cantidad: self.cantidad,
        }
      )
        .then((res) => {
          localStorage.setItem("fecha_proceso", new Date());
          self.cleanErrors();
          $("#pickearModal").modal("hide");
          self.refreshDetalleDefault();
          self.$emit("refreshCurrent");
          self.cleanDataInputs();
          self.cleanErrors();
        })
        .catch((err) => {
          self.$emit("refreshCurrent");
          console.log(err.response.data);
          self.error_pickeo = err.response.data;
          self.cleanDataInputs();
          if (err.response.data.detail) {
            Notifications.alert.error("Pickear producto", err.response.data.detail);
          }
        });
    },
    cleanDataInputs() {
      let self = this;
      self.producto = "";
      self.barra = null;
      self.localizacion_origen = null;
      self.cantidad = null;
      self.lote = null;
    },
    cleanErrors() {
      let self = this;
      this.error_pickeo = null;
    },
  },
};
</script>
